import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/new/31.png';
import _imports_1 from '../../../assets/new/32.png';
import _imports_2 from '../../../assets/new/39.png';
import _imports_3 from '../../../assets/new/40.png';
import _imports_4 from '../../../assets/new/49.png';
import _imports_5 from '../../../assets/new/9.png';
import _imports_6 from '../../../assets/new/51.png';
const _withScopeId = n => (_pushScopeId("data-v-9b02bef2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-9b02bef2><div data-v-9b02bef2><h3 data-v-9b02bef2>我的订购</h3><span data-v-9b02bef2>您的最爱，我们都为您保存好啦</span></div><img src=\"" + _imports_1 + "\" data-v-9b02bef2></div><div class=\"list\" data-v-9b02bef2><a href=\"javascript: void(0)\" data-v-9b02bef2><img src=\"" + _imports_2 + "\" data-v-9b02bef2><h4 data-v-9b02bef2>安妮日记</h4><span data-v-9b02bef2>零基础</span></a><a href=\"javascript: void(0)\" data-v-9b02bef2><img src=\"" + _imports_2 + "\" data-v-9b02bef2><h4 data-v-9b02bef2>安妮日记</h4><span data-v-9b02bef2>零基础</span></a><a href=\"javascript: void(0)\" data-v-9b02bef2><img src=\"" + _imports_2 + "\" data-v-9b02bef2><h4 data-v-9b02bef2>安妮日记</h4><span data-v-9b02bef2>零基础</span></a><a href=\"javascript: void(0)\" data-v-9b02bef2><img src=\"" + _imports_2 + "\" data-v-9b02bef2><h4 data-v-9b02bef2>安妮日记</h4><span data-v-9b02bef2>零基础</span></a><a href=\"javascript: void(0)\" data-v-9b02bef2><img src=\"" + _imports_2 + "\" data-v-9b02bef2><h4 data-v-9b02bef2>安妮日记</h4><span data-v-9b02bef2>零基础</span></a><a href=\"javascript: void(0)\" class=\"add\" data-v-9b02bef2><img src=\"" + _imports_3 + "\" data-v-9b02bef2><span data-v-9b02bef2>添加课程</span></a></div><div style=\"height:6rem;\" data-v-9b02bef2></div>", 3);
const _hoisted_8 = {
  class: "footer"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6
}, null, -1));
import { computed } from "vue";
import { useRouter } from "vue-router";
import { getLocalPid } from "../../../libs/util";
export default {
  __name: 'myCourse_copy',
  setup(__props) {
    const isMobile = computed(() => {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let getArr = Agents.filter(i => userAgentInfo.includes(i));
      return getArr.length ? true : false;
    });
    const pid = getLocalPid();
    const router = useRouter();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([isMobile.value ? 'isMobile' : 'isPc'])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).go(-1))
      }, _hoisted_4), _createTextVNode(" 我的课程 ")]), _hoisted_5, _createElementVNode("div", _hoisted_8, [_createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[1] || (_cache[1] = $event => _unref(router).push({
          name: 'index',
          query: {
            pid: _unref(pid)
          }
        }))
      }, [_hoisted_9, _createTextVNode(" 原版阅读 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[2] || (_cache[2] = $event => _unref(router).push({
          name: 'photo',
          query: {
            pid: _unref(getLocalPid)()
          }
        }))
      }, [_hoisted_10, _createTextVNode(" AI工具 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        style: {
          "color": "#35b9ff"
        },
        onClick: _cache[3] || (_cache[3] = $event => _unref(router).push({
          name: 'my',
          query: {
            pid: _unref(getLocalPid)()
          }
        }))
      }, [_hoisted_11, _createTextVNode(" 个人中心 ")])])])], 2);
    };
  }
};